export default __webpack_public_path__ + "static/media/card7.e514ccd5.jpg";